import { AxiosResponse } from 'axios'
import { ErrorCode } from './error'

export interface Response {
  // `data` is the response that was provided by the server
  readonly data: {} | string | undefined | Blob | any

  // `httpCode` is the HTTP status code from the server response
  readonly httpCode: number | undefined

  // `errorCode` is the Server status code
  readonly errorCode: ErrorCode | undefined

  // `statusText` is the HTTP status message from the server response
  readonly status: string | undefined

  // `headers` the headers that the server responded with
  readonly headers: { [key: string]: string } | undefined

  // `message` is built at the client in case server failed to send the message
  readonly message?: string | undefined
}

export const getResponseData = (response: AxiosResponse) => {
  if (response && response.data) {
    return response.data
  }
  return {}
}

export const getResponseHTTPStatusCode = (response: AxiosResponse) => {
  if (response && response.status) {
    return response.status
  }
  return 200
}

export const getResponseHTTPStatus = (response: AxiosResponse) => {
  if (response && response.data && response.data.status) {
    return response.data.status
  }
  return 'SUCCESS'
}

export const getResponseHTTPHeaders = (response: AxiosResponse) => {
  if (response && response.headers) {
    return response.headers
  }
  return undefined
}
